import {
    EFE_ACTIVITY_FE_UTIL,
    getPreNumInfoByApi,
    toggleCppIOSLink,
    isPc,
    formatNumberWithCommas,
    isIOS,
    useIntersectionObserver,
    getCampaignName,
} from '@efe-activity-fe-util/core'
import Config from '../libs/config.json'
import { PC_CONFIG, MB_CONFIG } from '../libs/gaConfig'
import {
    IOS_CPP_LINK_CONFIG,
    IOS_STORE_CPP_LINK_CONFIG,
    AND_CPP_LINK_CONFIG,
    AND_STORE_CPP_LINK_CONFIG,
    DEFAULT_LINK_CONFIG,
    TEXT_CPP_LINK,
} from '../constants/link'
import {
    ALL_GP_SELECTOR,
    ALL_IOS_SELECTOR,
    FB_BTN_SELECTOR,
    TWITTER_BTN_SELECTOR,
    DISCORD_BTN_SELECTOR,
    PANGLE_GP_BUTTONS,
    PANGLE_IOS_BUTTONS,
    PRE_SUCCESS_POPUP_SELECTOR,
    HAD_PRE_POPUP_SELECTOR,
    INPUT_ERROR_POPUP_SELECTOR,
    PRE_POPUP_SELECTOR,
    PHONE_SELECTOR,
} from '../constants/selector'
import { usePopup } from '../hooks/usePopup'
import { storeTrack } from './storeTrack'
import { isShortPage, isStorePage, isTextCppLink } from '../utils/is'
import { getHtmlFileNameWithoutExt, getPageClasses } from '../utils/general'
import { POPUP_FROM_SCROLL, POPUP_FROM_SET } from 'src/constants/trackClass'
import { getPreStatus } from './phonePre'
import { getPreStatus as getStorePreStatus } from './shopPre'
// @ts-ignore
// import PcKV from '../images/KV4/pc.mp4'
// import MbKV from '../MB.mp4'

const { openPopup, closePopupAll } = usePopup()

export function initPage() {
    // 初始化 ABT 视频
    initVideo()

    // 初始化页面版本：电话版 or 商店版 or 遮羞版
    initPageVersion()

    // 初始化页面多语言切换
    // initPageAnchor()

    // 初始化 @efe-activity-fe-util 工具
    initUtilConfig()

    // 初始化页面上所有商店按钮链接
    initStoreBtnLink()

    // 初始化商店按钮埋点
    initStoreTrack()

    // 初始化预约人数
    initPreNumber()

    // 初始化角色轮播图：有操作时暂停播放
    // initRoleSwiper()
}

function initRoleSwiper() {
    function pauseAutoplayWithDelay() {
        window.roleSwiper?.autoplay.stop()
    }

    const el = document.querySelector('.container2')

    if (el) {
        useIntersectionObserver(
            el,
            ([entry]) => {
                if (entry.isIntersecting) {
                    window.roleSwiper?.autoplay.start()
                } else {
                    setTimeout(() => {
                        window.roleSwiper?.slideTo(isPc() ? 0 : 0)
                    }, 100)
                    pauseAutoplayWithDelay()
                }
            },
            { threshold: 0.5 }
        )
    }

    $('.role-container').on(
        'mousedown touchstart click',
        '.swiper-slide, .shapeshifting, .btn-video, .swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet',
        pauseAutoplayWithDelay
    )
}

function initVideo() {
    // window.kvUrl = isPc()
    //     ? 'https://resgl-download.efunsea.com/res_gl/eud3/eud3Pre/KV1/PC.mp4'
    //     : MbKV
    // window.kvUrl = isPc() ? PcKV : MbKV

    if (typeof window.lozad !== 'function' || !window.kvUrl) {
        return
    }

    $('.kv-video').show().addClass('loaded').append(
        // @ts-ignore
        `<video class="kv-video-box lozad" autoplay muted loop playsinline><source src="${window.kvUrl}"></source></video>`
    )

    if (isPc()) {
        $(window).on('hashchange', () => {
            const { hash } = window.location
            if (hash === '#section-01') {
                ;($(`.kv-video-box`)[0] as HTMLVideoElement)?.play?.()
            }
        })
    }
}

function initPageVersion() {
    $('#app').addClass(getPageClasses())
    // $.extend(($.fn.bPopup as any).defaults, { appendTo: '#app' })
}

function initPageAnchor() {
    const normalizePath = (path: string) => {
        if (!path.startsWith('/')) {
            path = '/' + path
        }
        if (path.endsWith('/')) {
            path = path.slice(0, -1)
        }
        return path
    }

    $('.page-anchor').on('click', (e) => {
        e.preventDefault()
        const { origin, search, hash, pathname } = window.location
        const htmlFilename = normalizePath(
            $(e.target).data('href') || 'index.html'
        )
        const url =
            origin +
            pathname.replace(/\/([^\/]*)$/, htmlFilename) +
            search +
            hash
        window.localStorage.setItem('lang_is_redirect', '1')
        window.location.href = url
    })
}

function initUtilConfig() {
    // const pageLang = getHtmlFileNameWithoutExt() || 'index'
    // const lang = {
    //     index: 'zh-CN',
    //     en: 'en-US',
    //     id: 'id-ID',
    //     th: 'th-TH',
    // }
    // Config.LANGUAGE = lang[pageLang] ?? Config.LANGUAGE
    new EFE_ACTIVITY_FE_UTIL(Config as any, isPc() ? PC_CONFIG : MB_CONFIG)
}

function initStoreTrack() {
    storeTrack()
}

async function initPreNumber() {
    const { data } = await getPreNumInfoByApi()
    const preNumber = Number(data?.totalPreNum)
    renderMask(preNumber)
}

function initStoreBtnLink() {
    const { ios, gp, fbClub, fbFans, twitter, discord } = DEFAULT_LINK_CONFIG

    const iosLink = isTextCppLink
        ? TEXT_CPP_LINK
        : toggleCppIOSLink(
              isStorePage || isShortPage
                  ? IOS_STORE_CPP_LINK_CONFIG
                  : IOS_CPP_LINK_CONFIG,
              ios
          )

    const ggLink = toggleCppIOSLink(
        isStorePage || isShortPage
            ? AND_STORE_CPP_LINK_CONFIG
            : AND_CPP_LINK_CONFIG,
        gp
    )

    $(ALL_IOS_SELECTOR).attr({ href: iosLink, target: '_blank' })
    $(ALL_GP_SELECTOR).attr({ href: ggLink, target: '_blank' })
    $(FB_BTN_SELECTOR).attr({ href: fbFans, target: '_blank' })
    $('.btn-facebook-club').attr({ href: fbClub, target: '_blank' })
    $(TWITTER_BTN_SELECTOR).attr({ href: twitter, target: '_blank' })
    $(DISCORD_BTN_SELECTOR).attr({ href: discord, target: '_blank' })
    $(PANGLE_GP_BUTTONS).attr({ href: ggLink, target: '_blank' })
    $(PANGLE_IOS_BUTTONS).attr({ href: iosLink, target: '_blank' })
}

function renderMask(total: number) {
    $('.sub-num').html(formatNumberWithCommas(total))

    if (total >= 50000) {
        $('.cleared1').show()
        $('.finsh-line').addClass('finsh1')
        $('.finsh-dot').addClass('step1')
    }
    if (total >= 100000) {
        $('.cleared2').show()
        $('.finsh-line').removeClass('finsh1').addClass('finsh2')

        $('.finsh-dot').removeClass('step1').addClass('step2')
    }
    if (total >= 200000) {
        $('.cleared3').show()
        $('.finsh-line').removeClass('finsh2').addClass('finsh3')
        $('.finsh-dot').removeClass('step2').addClass('step3')
    }
    if (total >= 300000) {
        $('.cleared4').show()
        $('.finsh-line').removeClass('finsh3').addClass('finsh4')
        $('.finsh-dot').removeClass('step3').addClass('step4')
    }
    if (total >= 777777) {
        $('.cleared5').show()
        $('.finsh-line').removeClass('finsh4').addClass('finsh5')
        $('.finsh-dot').removeClass('step4').addClass('step5')
        $('.progress-bar').addClass('finsh-on')
    }
}
